import { render, staticRenderFns } from "./ReportMaterialsAvailable.vue?vue&type=template&id=386dcf6b&"
import script from "./ReportMaterialsAvailable.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign({QItem,QTr,QTh,QTd}, component.options.components || {})
